import { useEffect, useState } from "react";
import { EditTwoTone } from "@ant-design/icons";
import { useAppSelector } from "../../../../redux/hooks";
import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  message,
  notification,
} from "antd";

import { callFetchPostByID, callUpdatePost } from "../../../../config/api";
import { createPost } from "../../../../types/backend";
import TextFormat from "../../../../components/TextFormat";

const { Option } = Select;

const ModalPost = ({
  id,
  handleFetchPost,
}: {
  id: string;
  handleFetchPost: any;
}): JSX.Element => {
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const categories = useAppSelector((state) => state.category.result);
  const [loading, setLoading] = useState(false)

  const showModal = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const fetchPostById = async () => {
    const result: any = await callFetchPostByID(id);
    form.setFieldsValue(result.data);
  };

  useEffect(() => {
    fetchPostById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, open]);

  const onFinish = async (values: createPost) => {
    setLoading(true)
    const res: any = await callUpdatePost(id, values);
    if (res && res.statusCode === 200) {
      handleFetchPost();
      message.success("update success!");
      setOpen(false);
    } else {
      notification.error({
        message: "Đã có lỗi xảy ra",
        description: res.message,
      });
    }
    setLoading(false)
  };

  return (
    <Spin spinning={loading}>
      <Button
        style={{ border: "1px solid #f57800" }}
        type="primary"
        ghost
        onClick={showModal}>
        <EditTwoTone twoToneColor="#f57800" style={{ cursor: "pointer" }} />
      </Button>
      <Modal
        title="Chỉnh sửa bài viết"
        open={open}
        onOk={() => {
          form.submit();
        }}
        okText="Lưu"
        cancelText="Hủy"
        maskClosable={false}
        width={840}
        onCancel={onClose}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="title"
                label="Title"
                rules={[{ required: true, message: "Please enter title" }]}>
                <Input
                  // onChange={(e) => setTitle(e.target.value)}
                  placeholder="Please enter title"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="image"
                label="Image"
                rules={[{ required: true, message: "Please enter title" }]}>
                <Input placeholder="Please enter title" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="categoryId"
                label="Category"
                rules={[
                  { required: true, message: "Please choose the category" },
                ]}>
                <Select placeholder="Please choose the category">
                  {categories.map((item) => (
                    <Option key={item._id} value={item._id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={24}>
              <TextFormat />
            </Col>
          </Row>
        </Form>
      </Modal>
    </Spin>
  );
};

export default ModalPost;
